import { Box, Grid, Input, Text } from '@chakra-ui/react';
import parsePhoneNumber from 'libphonenumber-js';
import { useMemo, useState } from 'react';
import { useFormContext } from 'react-hook-form-6';

import PhoneInput from '@/components/atoms/PhoneInput';

export default function WedissimoUserForm() {
  const { register, setValue } = useFormContext();

  const [firstName, setFirstName] = useState('Test');
  const [lastName, setLastName] = useState('Test');
  const [email, setEmail] = useState('abc@def.com');
  const [profilePicUrl, setProfilePicUrl] = useState('https://www.com');
  const [icsUrl, setIcsUrl] = useState('https://www.com');
  const [mobile, setMobile] = useState('+441234567890');

  const isFirstNameValid = true; // useMemo(() => firstName.length > 0, [firstName]);
  const isLastNameValid = true; // useMemo(() => lastName.length > 0, [lastName]);
  const isEmailValid = true; // useMemo(() => email.length > 0, [email]);

  const isMobileValid = useMemo(
    () => {
      try {
        const phoneNumber = parsePhoneNumber(mobile);

        // Update hidden field to ensure form context receives full phone value
        setValue('mobile', mobile);

        return (phoneNumber && phoneNumber.isValid());
      } catch (error) {
        return false;
      }
    }, [mobile, setValue]
  );

  const isProfilePicUrlValid = true; // useMemo(() => profilePicUrl.length > 0, [profilePicUrl]);
  const isIcsUrlValid = true; // useMemo(() => icsUrl.length > 0, [icsUrl]);

  

  return (
    <Box py={4} px={6} borderWidth={1} borderColor="gray.300" fontFamily="Source Sans Pro">
        <Grid
          alignItems="center"
          columnGap={2}
          rowGap={5}
          templateColumns="20ch auto 1fr"
          pb={2}
        >
          <Text>First Name</Text>

          <Input
            name='firstName'
            onChange={(event) => setFirstName(event.target.value)}
            isInvalid={firstName.length > 0 && !isFirstNameValid}
            ref={(element) => {register()(element);}}
          />
        </Grid>

        <Grid
          alignItems="center"
          columnGap={2}
          templateColumns="20ch auto 1fr"
          pb={2}
        >
          <Text>Last Name</Text>
          <Input
            name='lastName'
            onChange={(event) => setLastName(event.target.value)}
            isInvalid={lastName.length > 0 && !isLastNameValid}
            ref={(element) => {register()(element);}}
          />
        </Grid>
  
        <Grid
          alignItems="center"
          columnGap={2}
          templateColumns="20ch auto 1fr"
          pb={2}
        >
          <Text>Email</Text>

          <Input
            name='email'
            onChange={(event) => setEmail(event.target.value)}
            isInvalid={email.length > 0 && !isEmailValid}
            ref={(element) => {register()(element);}}
          />
        </Grid>

        <Grid
          alignItems="center"
          columnGap={2}
          templateColumns="20ch auto 1fr"
          pb={2}
        >
          <Text>Profile Picture URL</Text>

          <Input
            name='profilePicUrl'
            onChange={(event) => setProfilePicUrl(event.target.value)}
            isInvalid={profilePicUrl.length > 0 && !isProfilePicUrlValid}
            ref={(element) => {register()(element);}}
          />
        </Grid>

        <Grid
          alignItems="center"
          columnGap={2}
          templateColumns="20ch auto 1fr"
          pb={2}
        >
          <Text>ICS URL</Text>

          <Input
            name='icsUrl'
            onChange={(event) => setIcsUrl(event.target.value)}
            isInvalid={icsUrl.length > 0 && !isIcsUrlValid}
            ref={(element) => {register()(element);}}
          />
        </Grid>

        <Grid
          alignItems="center"
          columnGap={2}
          templateColumns="20ch auto 1fr"
          pb={2}
        >
          <Text>Phone Number</Text>

          <PhoneInput
            name="fullPhoneNumber"
            onChange={(event) => setMobile(event)}
            isInvalid={mobile.length > 0 && !isMobileValid}
            isError={!isMobileValid}
            ref={(element) => {register()(element);}}
          />
          
          <input type="hidden" name="mobile" ref={(element) => {register()(element);}} />
      </Grid>
    </Box>
  );
}
